import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/builders/$builder_id/communities/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/builders/$builder_id/locations",
      params: { builder_id: params.builder_id },
      statusCode: 301,
    });
  },
});
